// extracted by mini-css-extract-plugin
module.exports = {"DocumentContainer":"DocumentContainer-module--DocumentContainer--3t-IR"};